import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Select } from "antd";

import CollapseHeader from "../../../../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../../../../router/all_routes";

import type { CompanyOption } from "../../../../../../core/data/redux/admin-leaves/types";

interface AdminLeavesHeaderProps {
  companies: CompanyOption[];
  activeCompanyKey: string | null;
  companiesLoading: boolean;
  onCompanyChange: (company: CompanyOption) => void;
  onExportClick: () => void;
  exportDisabled?: boolean;
}

const filterOption = (input: string, option?: { label: string; value: any }) =>
  (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase());

const AdminLeavesHeader: React.FC<AdminLeavesHeaderProps> = ({
  companies,
  activeCompanyKey,
  companiesLoading,
  onCompanyChange,
  onExportClick,
  exportDisabled = false,
}) => {
  const handleSelect = (value: string) => {
    const match = companies.find((c) => c.value === value);
    if (match) onCompanyChange(match);
  };

  return (
    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <div className="my-auto mb-2">
        <h2 className="mb-1">Leaves</h2>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={all_routes.adminDashboard}>
                <i className="ti ti-smart-home" />
              </Link>
            </li>
            <li className="breadcrumb-item">Employee</li>
            <li className="breadcrumb-item active" aria-current="page">
              Leaves
            </li>
          </ol>
        </nav>
      </div>

      <div className="d-flex align-items-center ms-auto flex-wrap gap-2 mb-2">
        <Select
          showSearch
          filterOption={filterOption}
          style={{ width: 260, minHeight: 38 }}
          placeholder="Select Company"
          value={activeCompanyKey || undefined}
          loading={companiesLoading}
          onChange={handleSelect}
          options={companies.map((c) => ({ value: c.value, label: c.label }))}
        />
        <Button
          variant="success"
          onClick={onExportClick}
          disabled={exportDisabled}
        >
          <i className="ti ti-download me-1"></i> Export Report
        </Button>
        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div className="head-icons mb-0">
            <CollapseHeader />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLeavesHeader;
